import React, {useCallback} from "react";
import {EmbedProviderProps} from "./EmbedProviders";
import {ensureScriptTag} from "./tagManager";
export function ContriblyGalleryV2({oembed}: EmbedProviderProps) {

  const ref = useCallback((element: HTMLDivElement|null) => {
     if(element) {
      if ((window as any).contriblyGalleryInitialized) {
        if((typeof (window as any).setupContriblyGalleryWidget !== 'undefined')){
          (window as any).setupContriblyGalleryWidget();
        }
      } else {
        (window as any).Contribly = (window as any).contriblyGalleryInitialized = true;
        ensureScriptTag({
          src: 'https://s3-eu-west-1.amazonaws.com/contribly-widgets/gallery/gallery-tickaroo.js',
          async: true,
          onload: () => (window as any).setupContriblyGalleryWidget()
        });
      }
    }
  }, [])

  return <div className="tik4-we-contribly" ref={ref} dangerouslySetInnerHTML={{__html: oembed.html || ""}} />
}

export default ContriblyGalleryV2
